import { render, staticRenderFns } from "./workerDetails.vue?vue&type=template&id=24814cce&scoped=true&"
import script from "./workerDetails.vue?vue&type=script&lang=js&"
export * from "./workerDetails.vue?vue&type=script&lang=js&"
import style0 from "./workerDetails.vue?vue&type=style&index=0&id=24814cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24814cce",
  null
  
)

export default component.exports